import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import SplashPage from './components/splash-page/SplashPage';
import About from './components/about/About';
import Resume from './components/resume/Resume';
import RockPaperScissors from './components/arcade/rockPaperScissors/RockPaperScissors';
import Contact from './components/contact/Contact';
import { Article, Home, Info, Email, VideogameAsset, MusicNote, Work } from '@mui/icons-material';
import Arcade from './components/arcade/arcade';
import Music from './components/music/music';
import Projects from './components/projects/Projects';

const routesConfig = [
  {
    name: "Home",
    path: "",
    component: SplashPage,
    navIcon: <Home />
  },
  {
    name: "Resume",
    path: "/resume",
    component: Resume,
    navIcon: <Article />
  },
  {
    name: "About",
    path: "/about",
    component: About,
    navIcon: <Info />
  },
  {
    name: "Rock Paper Scissors",
    path: "/rock-paper-scissors",
    component: RockPaperScissors,
    hidden: true
  },
  {
    name: "Arcade",
    path: "/arcade",
    component: Arcade,
    navIcon: <VideogameAsset />,
    hidden: true
  },
  {
    name: "Music",
    path: "/music",
    component: Music,
    navIcon: <MusicNote />,
    hidden: true
  },
  {
    name: "Projects",
    path: "/resume/projects",
    component: Projects,
    navIcon: <Work />
  }
  // {
  //   name: "Contact",
  //   path: "/contact",
  //   component: Contact,
  //   navIcon: <Email />
  // },
];

export default routesConfig;